// extracted by mini-css-extract-plugin
export default {"icons":"hand-care_icons__2BhtR","icon":"hand-care_icon__dg-S+","hyphens":"hand-care_hyphens__Kbnsn","imgWrapper":"hand-care_imgWrapper__RuA-W","iconText":"hand-care_iconText__hbu1z"};